import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import AppContext from '../../context';
import './upgrade_modal.component.css';

const UpgradeModal = (props) => {
  const context = useContext(AppContext);

  const handleSignUpPro = () => {
    const link = '/account/subscription/';
    window.location = link;
  };

  return (
    <Modal
      show={props.isVisible}
      centered
      onHide={() => props.setIsVisible(false)}
      className="upgrade-plan"
    >
      <Modal.Body className="text-center">
        <div className="head mt-2">Premium Feature</div>
        <div>
          <div className="upgrade-to">
            {context.user.is_authenticated ? 'UPGRADE TO ' : 'SUBSCRIBE TO '}
            <strong>PREMIUM PLAN</strong>&nbsp;AND GET ACCESS TO
          </div>
          <div className="plan-card premium">
            <div className="head">All the advantages of Free plan, plus:</div>
            <div>
              <div className="sub_head">TRACKING</div>
              <ul className="mb-0">
                <li>
                  <i className="fa fa-check"></i>5 Portfolio Accounts
                </li>
                <li>
                  <i className="fa fa-check"></i>
                  10 Watchlists
                </li>
                <li>
                  <i className="fa fa-check"></i>
                  Unlimited Alerts
                </li>
              </ul>
            </div>
            <div>
              <div className="sub_head">FINANCIAL RESEARCH</div>
              <ul className="mb-0">
                <li>
                  <i className="fa fa-check"></i>
                  In-Depth Comparison of Financials
                </li>
                <li>
                  <i className="fa fa-check"></i>
                  Reverse DCF
                </li>
              </ul>
            </div>
            <div>
              <div className="sub_head">FUNDAMENTAL RESEARCH</div>
              <ul className="mb-0">
                <li>
                  <i className="fa fa-check"></i>
                  Operational Metrics - Historic Data of 6000+ Metrics
                </li>
                <li>
                  <i className="fa fa-check"></i>
                  Historic Data of
                  <div className="pl-4">
                    Market Share, Revenue Mix, Market Monitor, Raw Materials,
                    Macro Indicator, Sector Research
                  </div>
                </li>
                <li>
                  <i className="fa fa-check"></i>
                  Source Links
                </li>
                <li>
                  <i className="fa fa-check"></i>
                  Unlimited Filter queries
                </li>
              </ul>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="signup-btn"
          onClick={() => handleSignUpPro()}
        >
          Upgrade to Premium Plan
        </button>
      </Modal.Body>
      <div className="close-btn" onClick={() => props.setIsVisible(false)}>
        &#10006;
      </div>
    </Modal>
  );
};

export default UpgradeModal;
